import { authenticatedAxiosInstance as axios } from "../axios";

const list = (params) => axios.get(`/reports/transactions`, params)
const print = (id) => axios.get(`/reports/transactions/${id}/print`)

export const ReportApi = {
    list,
    print
}
